module.exports = __webpack_public_path__ + "media/images/front/pc/institution-treatment-information/bnr_728_90-51da5dd8c27d3fdb0a5ac3644310ec53.png";